import React from 'react'
import PropTypes from 'prop-types'
import { Text, ContentLoader } from 'shared/components'

import { TeamCard } from './components/teamCard'
import * as styles from './styles'

const TournamentTeamsTabComponent = ({ teams, localTeams, loading, error, onToggleFollow }) => {
	// Use localTeams if available, otherwise fall back to teams from async effect
	const displayTeams = (localTeams && localTeams.length > 0) ? localTeams : (teams || [])

	if (loading) {
		return (
			<div css={styles.container}>
				<ContentLoader loading={true}>
					<div css={styles.loadingPlaceholder}>
						<Text size={12} css={styles.loadingText}>
							Loading teams...
						</Text>
					</div>
				</ContentLoader>
			</div>
		)
	}

	if (error) {
		return (
			<div css={styles.container}>
				<div css={styles.errorContainer}>
					<Text size={14} color="red">
						Failed to load teams
					</Text>
				</div>
			</div>
		)
	}

	if (!displayTeams || displayTeams.length === 0) {
		return (
			<div css={styles.container}>
				<div css={styles.emptyContainer}>
					<Text size={14}>
						No teams available for this tournament
					</Text>
				</div>
			</div>
		)
	}

	return (
		<div css={styles.container}>
			<div css={styles.teamsGrid}>
				{displayTeams.map((team, index) => (
					<TeamCard
						key={team.id || `team-${index}`}
						team={team}
						onToggleFollow={onToggleFollow}
					/>
				))}
			</div>
		</div>
	)
}

TournamentTeamsTabComponent.propTypes = {
	teams: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		teamName: PropTypes.string,
		abbreviation: PropTypes.string,
		logo: PropTypes.string,
		sport: PropTypes.string,
		followed: PropTypes.bool,
	})),
	localTeams: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		teamName: PropTypes.string,
		abbreviation: PropTypes.string,
		logo: PropTypes.string,
		sport: PropTypes.string,
		followed: PropTypes.bool,
	})),
	loading: PropTypes.bool,
	error: PropTypes.string,
	onToggleFollow: PropTypes.func,
}

TournamentTeamsTabComponent.defaultProps = {
	teams: [],
	localTeams: [],
	loading: false,
	error: null,
}

export default TournamentTeamsTabComponent 